import React from 'react'
import { useTranslation } from 'react-i18next'

import { useReactiveVar } from '@apollo/client'
import { Box, Button, Typography } from '@mui/material'
import { intlFormat } from 'date-fns'
import PropTypes from 'prop-types'
import { Analytics } from 'shared-components'

import { store } from '../../cache'
import i18next from '../../i18n'

export const FirstAvailable = ({
  firstAvailableDay,
  onDaySelected,
  onChangeDate,
}) => {
  const { locationId, partnerId } = useReactiveVar(store)
  const { t } = useTranslation()
  const langCode = i18next.language
  if (firstAvailableDay) {
    const formattedFirstAvailableDate = intlFormat(
      firstAvailableDay.date,
      { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' },
      { locale: langCode }
    )

    const selectFirstAvailableDay = () => {
      Analytics.firstAvailableSelected({ locationId, partnerId })
      onChangeDate(firstAvailableDay.date)
      onDaySelected(firstAvailableDay.date, { times: firstAvailableDay.times })
    }

    return (
      <Box
        data-testid="first-available-container"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        gap={1}
        pb={2}
      >
        <Typography variant="subtitle1" color="">
          {t('The next available appointment is:')}
        </Typography>
        <Button
          variant="text"
          color="primary"
          onClick={() => selectFirstAvailableDay()}
          sx={{ px: 2 }}
        >
          {formattedFirstAvailableDate}
        </Button>
      </Box>
    )
  }
}

FirstAvailable.propTypes = {
  firstAvailableDay: PropTypes.shape({
    date: PropTypes.instanceOf(Date),
    times: PropTypes.array,
  }),
  onDaySelected: PropTypes.func,
  onChangeDate: PropTypes.func.isRequired,
}
